import React, { Component } from 'react'
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import axios from 'axios'
import CommonToast from '../Toaster/CommonToast';
import CommonLoader from '../loaderComponent/CommonLoader';
import { validateAdjustAmount } from '../../utils/validation';

export default class EditSalary extends Component {

  constructor(props) {
    super(props);
    this.state = {
      financialData: this.props.location.state?.financialInfo,
      advanceSalaryData: "",
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
      loading: false,
      spinnerLoading: false,
      adjustAmount: '',
      enableSubmit: true
    }

  }
  handleBack = () => {
    this.props.history.push('/salary-list')
  }

  componentDidMount() {
    this.fetchData();
  }
  fetchData =
    async () => {
      this.setState({ loading: true });

      try {
        const { financialData } = this.state;
        const empId = financialData?.empid;

        if (!empId) {
          console.warn("Employee ID not found");
          this.setState({ loading: false });
          return;
        }

        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.get(`/financialInformations/advances/${empId}`, { headers });

        this.setState({ advanceSalaryData: response.data });
        console.log("Advance Salary Data:", response.data);

      } catch (error) {
        console.error("Error fetching advance salary data:", error);
        // Optionally: show toast message or set error state
      } finally {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      }
    };

  handleAdjustAmountChange = (e) => {
    const value = e.target.value;
    const advanceSalary = this.state.advanceSalaryData?.salaryAdvance;
    // console.log("this.state.advanceSalarydata", this.state.advanceSalaryData);
    let errorMsg = "";

    if (!value) {
      errorMsg = "Adjust amount is required.";
    } else if (parseFloat(value) > parseFloat(advanceSalary)) {
      errorMsg = `Adjust amount cannot be more than ₹${advanceSalary}`;
      this.setState({ enableSubmit: false })
    }
    else {
      this.setState({ enableSubmit: true })
    }
    this.setState((prevState) => ({
      adjustAmount: value,
      errors: {
        ...prevState.errors,
        adjustAmount: errorMsg
      }
    }));
  };

  handleSalaryUpdate = async () => {
    this.setState({ spinnerLoading: true })
    const { adjustAmount, financialData } = this.state;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const errors = validateAdjustAmount(
      this.state.adjustAmount
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false, spinnerLoading: false });
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const adjustAmountPayload = {
        empid: financialData?.empid,
        id: financialData?.id,
        adjustAmount: adjustAmount
      }
      await axios.post(`/salary/adjust`, adjustAmountPayload, { headers });
      this.setState({
        adjustAmount: '',
        toastMessage: 'Adjusted amount updated successfully!',
        toastVariant: 'success',
        showToast: true,
        color: 'green'
      });
      setTimeout(() => {
        this.setState({ loading: false, spinnerLoading: false, showToast: false });
        this.props.history.push("/salary-list");
      }, 900);


    } catch (error) {
      const errorMsg = error.response.data.error
      this.setState({
        toastMessage: errorMsg,
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });

      setTimeout(() => {
        this.setState({ loading: false, spinnerLoading: false, showToast: false });
      }, 2000);
    }
  }


  render() {
    return (
      <>
        <CommonLoader isLoading={this.state.loading}>
          <div className="container-fluid pt-4">
            <CommonToast
              show={this.state.showToast}
              onClose={() => this.setState({ showToast: false })}
              message={this.state.toastMessage}
              variant={this.state.toastVariant}
              color={this.state.color}
            />
            <div className='back-btn-edit-salary'>
              <Button variant='outline-primary' onClick={this.handleBack}><i class="fas fa-arrow-alt-circle-right"></i></Button>
            </div>
            <Card>
              <Card.Header>
                <strong>Edit Salary</strong>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="employeeName">
                        <Form.Label>Employee Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="employeeName"
                          value={this.state.financialData?.employeeName}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="salaryBasic">
                        <Form.Label>Salary Basic</Form.Label>
                        <Form.Control
                          type="text"
                          name="salaryBasic"
                          value={this.state.financialData?.salaryBasic}
                          readOnly
                        >
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="salaryNet">
                        <Form.Label>Net Salary</Form.Label>
                        <Form.Control
                          type="text"
                          name="salaryNet"
                          value={this.state.financialData?.salaryNet}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="advanceSalary">
                        <Form.Label>Advance Salary</Form.Label>
                        <Form.Control
                          type="text"
                          name="advanceSalary"
                          value={this.state.advanceSalaryData?.salaryAdvance}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Editable field for updating Net Salary */}
                  <Row className="mb-3">
                    {/* <Col md={4}></Col> */}
                    <Col md={3}>
                      <Form.Group controlId="year">
                        <Form.Label>Year</Form.Label>
                        <Form.Control
                          type="text"
                          name="year"
                          value={this.state.financialData?.year}
                          readOnly
                        >
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="salaryGross">
                        <Form.Label>Salary Gross</Form.Label>
                        <Form.Control
                          type="text"
                          name="salaryGross"
                          value={this.state.financialData?.salaryGross}
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group controlId="adjustAmount">
                        <Form.Label>Adjust Amount</Form.Label>
                        <Form.Control
                          type="text"
                          name="adjustAmount"
                          value={this.state.adjustAmount}
                          onChange={this.handleAdjustAmountChange}
                          // onChange={(e) => {
                          //   const value = e.target.value;
                          //   this.setState((prevState) => ({
                          //     adjustAmount: value,
                          //     errors: {
                          //       ...prevState.errors,
                          //       adjustAmount: value ? "" : prevState.errors.adjustAmount
                          //     }
                          //   }));
                          // }}
                          placeholder="Enter adjust amount"
                        />
                      </Form.Group>
                      <span className="login-error">
                        {this.state.errors.adjustAmount && <small className="text-danger">{this.state.errors.adjustAmount}</small>}
                      </span>
                    </Col>
                    <Col md={2} className="d-flex align-items-end ">
                      <div className={`submit-btn-edit-salary ${this.state.errors.adjustAmount ? 'submit-btn-edit-salary-error' : ''
                        }`}>
                        {
                          this.state.enableSubmit &&
                          <Button
                            variant="outline-primary"
                            className="me-2 submit-btn-loading"

                            onClick={this.handleSalaryUpdate}
                            disabled={this.state.spinnerLoading}
                          >
                            {this.state.spinnerLoading ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />{" "}
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        }
                        <Button
                          variant="outline-danger"
                          onClick={() => this.setState({ adjustAmount: '' })}
                        >
                          Clear
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="month">
                        <Form.Label>Month</Form.Label>
                        <Form.Control
                          type="text"
                          name="month"
                          value={this.state.financialData?.month}
                          readOnly
                        >
                        </Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="TotalDaysWorked">
                        <Form.Label>Total Days Worked</Form.Label>
                        <Form.Control
                          type="text"
                          name="TotalDaysWorked"
                          value={this.state.financialData?.TotalDaysWorked}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="allowanceHouseRent">
                        <Form.Label>Allowance House Rent</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceHouseRent"
                          value={this.state.financialData?.allowanceHouseRent}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="AdvanceAdjust">
                        <Form.Label>Advance Adjust</Form.Label>
                        <Form.Control
                          type="text"
                          name="AdvanceAdjust"
                          value={this.state.financialData?.AdvanceAdjust}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">

                    <Col md={3}>
                      <Form.Group controlId="allowanceFuel">
                        <Form.Label>Allowance Fuel</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceFuel"
                          value={this.state.financialData?.allowanceFuel}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="allowanceSpecial">
                        <Form.Label>Allowance Special</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceSpecial"
                          value={this.state.financialData?.allowanceSpecial}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="allowanceMedical">
                        <Form.Label>Allowance Medical</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceMedical"
                          value={this.state.financialData?.allowanceMedical}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="allowanceOther">
                        <Form.Label>Allowance Other</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceOther"
                          value={this.state.financialData?.allowanceOther}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="allowancePhoneBill">
                        <Form.Label>Allowance Phone Bill</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowancePhoneBill"
                          value={this.state.financialData?.allowancePhoneBill}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="allowanceTotal">
                        <Form.Label>Allowance Total</Form.Label>
                        <Form.Control
                          type="text"
                          name="allowanceTotal"
                          value={this.state.financialData?.allowanceTotal}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="deductionOther">
                        <Form.Label>Deduction Other</Form.Label>
                        <Form.Control
                          type="text"
                          name="deductionOther"
                          value={this.state.financialData?.deductionOther}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="deductionProvidentFund">
                        <Form.Label>Deduction Provident Fund</Form.Label>
                        <Form.Control
                          type="text"
                          name="deductionProvidentFund"
                          value={this.state.financialData?.deductionProvidentFund}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="deductionTax">
                        <Form.Label>Deduction Tax</Form.Label>
                        <Form.Control
                          type="text"
                          name="deductionTax"
                          value={this.state.financialData?.deductionTax}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="deductionTotal">
                        <Form.Label>Deduction Total</Form.Label>
                        <Form.Control
                          type="text"
                          name="deductionTotal"
                          value={this.state.financialData?.deductionTotal}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Group controlId="dateOfPayment">
                        <Form.Label>Payment Date</Form.Label>
                        <Form.Control
                          type="text"
                          name="dateOfPayment"
                          value={this.state.financialData?.dateOfPayment ? this.state.financialData?.dateOfPayment : 'N/A'}
                          readOnly
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </>
    )
  }
}
